class PostIn extends HTMLElement {
  constructor() {
    super();

    // Variables
    // ==========
    this.form = this.querySelector('#post-in-form');
    this.quotedPriceField = this.querySelector('#pre-quote-price');
    this.deviceModelField = this.querySelector('#make-and-model');
    this.conditionField = this.querySelector('#condition');
    this.shippingMethodField = this.querySelector('#shipping-method');
    this.emailAndLabelField = this.querySelector('#email-and-label');
    this.errorMessage = this.querySelector('.post-in__error-message');
    this.spinner = this.querySelector('.post-in__spinner');
    this.submitButton = this.querySelector('button[type="submit"]');

    // Event listeners
    // ================
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    
    // Update email-and-label value based on shipping method
    if (this.shippingMethodField) {
      this.shippingMethodField.addEventListener('change', this.updateEmailAndLabel.bind(this));
    }
  }
  
  connectedCallback() {
    this.loadTradeInData();
  }
  
  loadTradeInData() {
    const storedData = sessionStorage.getItem('selectedTradeInModel');
    
    if (!storedData) return; // Exit early if no data exists
    
    const modelData = JSON.parse(storedData);
    
    // Update the quoted price field
    if (this.quotedPriceField && modelData.price > 0) {
      this.quotedPriceField.value = modelData.price;
    }
    
    // Update the device make/model field
    if (this.deviceModelField && modelData.name) {
      const deviceInfo = `${modelData.device.replace(/\+/g, ' ')} - ${modelData.name}`;
      this.deviceModelField.value = deviceInfo;
    }
    
    // Update the condition field
    if (this.conditionField && modelData.condition) {
      // Map the condition from trade-in to post-in format
      let conditionValue = '';
      switch(modelData.condition) {
        case 'Grade A Buy (80%+)':
          conditionValue = 'Excellent';
          break;
        case 'Grade B Buy (80%+)':
          conditionValue = 'Good';
          break;
        case 'Grade D Buy':
          conditionValue = 'Faulty/damaged';
          break;
        default:
          conditionValue = '';
      }
      
      if (conditionValue) {
        this.conditionField.value = conditionValue;
      }
    }
  }
  
  updateEmailAndLabel() {
    if (!this.shippingMethodField || !this.emailAndLabelField) return;
    
    const shippingMethod = this.shippingMethodField.value;
    
    if (shippingMethod === "I'll post it myself") {
      this.emailAndLabelField.value = "No Action Required";
    } else if (shippingMethod === "Pre-Paid Label (Printer Required)") {
      this.emailAndLabelField.value = "Attach Label for Printing";
    } else if (shippingMethod === "Pre-Paid Label (No Printer)") {
      this.emailAndLabelField.value = "Send Packaging + Label";
    }
  }
  
  handleSubmit(e) {
    e.preventDefault();
    
    if (!this.validateForm()) {
      return;
    }

    this.submitButton.classList.add('hidden');
    this.spinner.classList.remove('hidden');
    
    // Collect form data
    const formData = new FormData(this.form);
    const formObject = Object.fromEntries(formData.entries());
    
    fetch('https://calatech-proxy-api.onrender.com/post-in', {
      method: 'POST',
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(formObject)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // Handle success - redirect or show success message
      console.log('Success:', data);
      // Clear session storage after successful submission
      sessionStorage.removeItem('selectedTradeInModel');
      this.success();
    })
    .catch(error => {
      // Handle error
      console.error('Error:', error);
      this.error(error);
    });
  }
  
  validateForm() {
    const requiredFields = this.form.querySelectorAll('[required]');
    let isValid = true;
    
    requiredFields.forEach(field => {
      if (!field.value.trim()) {
        isValid = false;
        field.classList.add('error');
      } else {
        field.classList.remove('error');
      }
    });
    
    return isValid;
  }
  
  success() {
    this.spinner.classList.add('hidden');
    this.submitButton.classList.remove('hidden');
    window.location.href = '/pages/sell-my-tech-post-in-confirmation';
  }
  
  error(error) {
    console.error(error);
    this.errorMessage.classList.remove('hidden');
  }
}

customElements.define('post-in', PostIn);